import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../components/providers/AppContextProvider";
import { UnhandledRouterLInk } from "./StyledReactRouterLink";

interface NavigateToPageLinkProps {
  pageRoute: string;
  linkText: ReactNode;
  nonLinkText?: string;
  navState?: any;
  dataTestId: string;
}

const NavigateToPageLink: React.FC<NavigateToPageLinkProps> = ({
  pageRoute,
  linkText,
  nonLinkText,
  navState,
  dataTestId,
}) => {
  const { theme } = useAppContext();

  const navigate = useNavigate();

  const handleNav = () => {
    let locationState = undefined;
    if (navState) {
      locationState = { state: { navState } };
    }
    navigate(pageRoute, locationState);
  };

  return (
    <span>
      <UnhandledRouterLInk
        style={{
          cursor: "pointer",
          paddingRight: "8px",
          textDecoration: "underline",
        }}
        theme={theme}
        onClick={() => handleNav()}
        data-testid={dataTestId}
      >
        {linkText}
      </UnhandledRouterLInk>
      {nonLinkText}
    </span>
  );
};

export default NavigateToPageLink;
